import React from 'react'
import { ProgramFilterType } from '~pages/home-page/const/types'
import { getCategoriesData } from '~shared/api/categories/getCategories'
import { Button } from '~shared/components/button-v2'
import { SearchInput } from '~shared/components/search-input'
import { Select } from '~shared/components/select'
import { FilterMenu } from '~shared/icons/filter-menu'
import { FilterDrawer } from './filter-drawer'
import { Drawer, DrawerTrigger } from '@/modules/components/ui/drawer'

type TSearchParams = {
  duration: { slug: string; name: string }
  faculty: { slug: string; name: string }
  category: { slug: string; name: string }
  format: { slug: string; name: string }
}

type Categories = Awaited<ReturnType<typeof getCategoriesData>>

type Props = {
  categories: Categories
  programsFilter: (categories: Categories) => ProgramFilterType
  searchParams: TSearchParams
  setSearchParams: React.Dispatch<React.SetStateAction<TSearchParams>>
  setShowedPrograms: React.Dispatch<React.SetStateAction<number>>
}

export const MobileFilter: React.FC<Props> = ({
  categories,
  setSearchParams,
  searchParams,
  setShowedPrograms,
  programsFilter
}) => {
  const [isShort, setIsShort] = React.useState(false)
  console.log(isShort)
  return (
    <div className='md:hidden flex  gap-[4px] mb-[30px]'>
      <Select
        searchParams={searchParams}
        selectData={programsFilter(categories)[0]!}
        setSearchParams={setSearchParams}
        setShowedPrograms={setShowedPrograms}
        isShort={isShort}
      />
      <SearchInput
        categories={categories}
        className='h-[65px] md:min-h-[67px] md:min-w-[67px]'
        setIsShort={setIsShort}
        isMobile
        isShort={isShort}
      />
      <Drawer direction='right'>
        <DrawerTrigger asChild>
          <Button className='bg-[#F0F0F0] min-h-[65px] min-w-[65px] text-black hover:text-white'>
            <FilterMenu />
          </Button>
        </DrawerTrigger>
        <FilterDrawer
          categories={categories}
          searchParams={searchParams}
          setSearchParams={setSearchParams}
          setShowedPrograms={setShowedPrograms}
        />
      </Drawer>
    </div>
  )
}
